import { StatisticsPublicApi } from 'SharedDir/backend/api';
import { makeRequest } from 'SharedDir/common/composables/useRequests';

export function usePublicStatistics() {
  const getUserList = async () => {
    // const { data: responseData } = await makeRequest(() => StatisticsPublicApi.getUsers());
    return [];
  };

  const getIssuesList = async (params) => {
    const { data: responseData } = await makeRequest(() => StatisticsPublicApi.getIssues(params));
    return responseData;
  };

  const getIssuesDepList = async () => {
    const { data: responseData } = await makeRequest(() => StatisticsPublicApi.getIssuesDep());
    return responseData;
  };

  const getServiceByDepartmentList = async () => {
    const responseData = await makeRequest(() => StatisticsPublicApi.getServiceByDepartment());
    return responseData;
  };

  return {
    getUserList,
    getIssuesList,
    getIssuesDepList,
    getServiceByDepartmentList,
  };
}
